import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectLeadsListItems } from "../../../../../../redux/leads/selector";
import { leads } from "../../../../../../redux/leads/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";



const LeadsContainers = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const itemsData = useSelector(selectLeadsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          
      { field: 'AnnualRevenue', headerName: 'Annual Revenue', isCurrencyValueFormat:true },
      { field: 'Industry', headerName: 'Industry', valueFormatter: getIndustryType, sortable: true, filter: true },
      { field: 'Company', headerName: 'Company' },
      { field: 'Rating', headerName: 'Rating', valueFormatter: getLeadRating, sortable: true, filter: true },
      { field: 'Email', headerName: 'Email', sortable: false, filter: true },
      { field: 'Source', headerName: 'Source', valueFormatter: getSalesSource },
      { field: 'FirstName', headerName: 'First Name',searchField: 'FirstName', sortable: true, filter: true, filterType: 'text' },
      { field: 'Status', headerName: 'Status', valueFormatter: getLeadStatus, isRowColorDecider: true, sortable: true, filter: true },
      { field: 'Mobile', headerName: 'Mobile' },
      { field: 'Phone', headerName: 'Phone' },
      { field: 'Website', headerName: 'Website' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat:true, sortable: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat:true, sortable: false }
      
        ]);
      }
    
      const getIndustryType = (id: any) => {
       }
    
      const getLeadRating = (id: any) => {
          }
    
      const getSalesSource = (id: any) => {
        }
    
      const getLeadStatus = (id: any) => {
        }

       
        const fetchLeads = () => {
          dispatch(leads.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/leads/list`,
            entity:'leads',
            jsonData:{
            "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
              }
            }))

        }

        useEffect(() => {
          createColumnDefs()
          fetchLeads()
      }, [pageData,pageSize])

      const handleAdd=()=>{
        navigate(`${0}`)
      }

        const handleDelete=(data: any)=>{
          dispatch(leads.delete({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/leads/delete`,
            entity: 'leads',
            jsonData: {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
          fetchLeads()
        });
        }
        
        const handleEdit = (data: any) => {
          navigate(`${data?.Id}`)
        }
        const handleReloadData = () => {
          fetchLeads()
        }
        const additionButtons: any = [
          {
            svg:
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                <title>Add Leads</title>
                <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
              </svg>,
            callback: () => handleAdd(),
          },
          {
            svg:
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                <title>Reload this table</title>
                <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>,
            callback: () => handleReloadData(),
          },
        ];
      
        const handleSearch = (data: any) => {
          let searchCriteria = {};
          if (data?.column) {
            searchCriteria = [{
              FieldName: data?.column,
              FieldText: data?.column,
              FieldType: 'text',
              FilterOperatorId: 6,
              FieldValue: data?.value
            }]
          } else {
            searchCriteria = [{
              FieldName: "FirstName",
              FieldText: "FirstName",
              FieldType: 'text',
              FilterOperatorId: 6,
              FieldValue: data?.value
            }]
          }
          dispatch(leads.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/leads/list`,
            entity: 'leads',
            jsonData: {
              "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",
              "Searches": searchCriteria,
            }
        }));
      }
	return (
    <>
    {itemsData?.isLoading ? 
      <PageLoader /> :
      <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
      enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Leads" />
    }
    </>
     
	);
};

export default LeadsContainers;


